export const publicPaths = ['/auth/register/', '/forgot-password'];